/**
 * LayoutDocs component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from "react-bootstrap"
import { useSpring, animated } from "react-spring"

import Header from "./header"
import Sidebar from "./doc-sidebars"
// import GoogleSearchSidebar from "./doc-sidebars/google-search"
import Footer from "./footer"

const LayoutDocs = ({ children, location }) => {
  const fade = useSpring({ from: { opacity: 0 }, opacity: 1 })

  const data = useStaticQuery(graphql`
    query DocSiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <animated.div style={fade} className="docs-layout">
        <div className="doc-body">
          <Container fluid={false} className="underlined">
            <Row className="docs-row">
              <Col md="4" lg="3" className="docs-sidebar">
                {"/docs" === location.pathname && <Sidebar />}
                {/*
                  '/docs/google' === location.pathname &&
                  <GoogleSearchSidebar />
                  */}
              </Col>
              <Col md="8" lg="9" className="docs-content">
                {children}
              </Col>
            </Row>
          </Container>
        </div>
      </animated.div>
      <Footer></Footer>
    </>
  )
}

LayoutDocs.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutDocs
